import { type MouseEventHandler } from 'react';
import Button from '@discover-ui/button';
import ChevronRightIcon from '@discover-ui/icons/chevron-right.svg';
import { cn } from '@discover-lib/utils';

export type PD6630SeeAllButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
};

export function PD6630SeeAllButton({ onClick, disabled = false }: PD6630SeeAllButtonProps) {
  return (
    <Button
      kind="outline"
      scale="sm"
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-hidden={disabled || undefined}
      tabIndex={disabled ? -1 : undefined}
      className="h-9 shrink-0 px-3 py-0 font-sans sm:h-12 sm:gap-1.5 sm:px-4 sm:text-base">
      See all
      <ChevronRightIcon aria-hidden="true" className="hidden size-4 shrink-0 sm:block" />
    </Button>
  );
}

export type PD6630CarouselHeaderProps = {
  heading: string;
  onSeeAllClick?: MouseEventHandler<HTMLButtonElement>;
  seeAllDisabled?: boolean;
  className?: string;
};

export const PD6630_CAROUSEL_HEADER_CLASS =
  'mb-3 flex items-center justify-between gap-3 px-4 sm:px-3 md:px-0 lg:mb-6';

export const PD6630_CAROUSEL_HEADING_CLASS =
  'm-0 min-w-0 font-sans text-base font-semibold text-ds-gray-light-950 sm:text-md';

export const PD6630_CAROUSEL_TRACK_CLASS =
  'mr-0 items-stretch gap-2 px-4 sm:mr-3 sm:gap-4 sm:pl-3 sm:pr-0 md:mr-0 md:px-0';

export const PD6630_CAROUSEL_ITEM_CLASS =
  'w-[272px] shrink-0 sm:w-[48%] sm:max-w-[270px] md:w-[38%] lg:w-[32%] xl:w-[28%]';

export default function PD6630CarouselHeader({
  heading,
  onSeeAllClick,
  seeAllDisabled = false,
  className,
}: PD6630CarouselHeaderProps) {
  return (
    <div className={cn(PD6630_CAROUSEL_HEADER_CLASS, className)}>
      <h2 className={PD6630_CAROUSEL_HEADING_CLASS}>{heading}</h2>
      <PD6630SeeAllButton onClick={onSeeAllClick} disabled={seeAllDisabled} />
    </div>
  );
}
